module.exports = __webpack_public_path__ + "static/media/QR.82403a61.gif";